module.exports = __webpack_public_path__ + "media/entities/1210-b11cb89f.png";